import { render, staticRenderFns } from "./AccordianMenu.vue?vue&type=template&id=b19f7646&scoped=true&"
import script from "./AccordianMenu.vue?vue&type=script&lang=js&"
export * from "./AccordianMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccordianMenu.vue?vue&type=style&index=0&id=b19f7646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19f7646",
  null
  
)

export default component.exports